export interface UtopSettings {
  id: string
  maxNumberOfIterations?: number
  populationSize?: number
  recordProgress?: boolean
  fitnessWeights: FitnessWeights
  dmObjective?: string
}

export interface FitnessWeights {
  cost: number
}

export const createSettings = (): UtopSettings => ({
  id: 'global',
  fitnessWeights: { cost: 1 },
  dmObjective: 'Cost',
})
